import { format, toZonedTime } from 'date-fns-tz';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PriceStampType } from '~/components/price-display-view/helpers/price-display-helpers';

import * as S from './PriceCellTooltip.styles';

const NEW_YORK_TIME_ZONE = 'America/New_York';

export const PriceCellTooltip = ({
  type,
  date,
}: {
  type: PriceStampType;
  date: string;
}) => {
  const { t } = useTranslation(['watchlistManager']);

  const lastTradeDate = format(date, 'h:mm:ss a z MMMM d, yyyy', {
    timeZone: NEW_YORK_TIME_ZONE,
  });

  const zonedDate = toZonedTime(date, 'UTC');
  const lastCloseDate = format(zonedDate, 'MMMM d, yyyy z', {
    timeZone: NEW_YORK_TIME_ZONE,
  });

  const getContent = () => {
    switch (type) {
      case 'notLive':
        return (
          <>
            <S.TimeLabel>
              {t('watchlistManager:priceCell.asOfDate', {
                date: lastTradeDate,
              })}
            </S.TimeLabel>
            <S.MarketClosedLabel>
              {t('watchlistManager:priceCell.marketClosed')}
            </S.MarketClosedLabel>
          </>
        );
      case 'live':
        return (
          <>
            <S.TimeLabel>
              {t('watchlistManager:priceCell.asOfDate', {
                date: lastTradeDate,
              })}
            </S.TimeLabel>
            <S.MarketOpenWrapper>
              <S.MarketOpenLabel>
                {t('watchlistManager:priceCell.marketOpen')}
              </S.MarketOpenLabel>
              <span>·</span>
              <S.LiveDataLabel>
                {t('watchlistManager:priceCell.liveData')}
              </S.LiveDataLabel>
            </S.MarketOpenWrapper>
          </>
        );
      default:
        return (
          <>
            <S.TimeLabel>{lastCloseDate}</S.TimeLabel>
            <S.AsOfLastCloseLabel>
              {t('watchlistManager:priceCell.asOfLastClose')}
            </S.AsOfLastCloseLabel>
          </>
        );
    }
  };

  return <S.Root>{getContent()}</S.Root>;
};
